import React, { FC, useEffect, useState } from 'react';

import { Course, Player, TeamGameMatch } from '../../../../../database.schema';
import { useFetchPlayers } from '../../../../api/hooks/use-fetch-players';
import { MATCH_FORMATS } from '../../../../app/constants';
import { TeamsDisplay } from './teams-display';
import { SinglesDisplay } from './singles-display';
import { PairsDisplay } from './pairs-display';

type EditTeamGameResultsProps = {
  match: TeamGameMatch;
  selectedTournamentIndex: number;
  matchIndex: number;
  courses: Array<Course>;
};

export const ApplyTeamGameResults: FC<EditTeamGameResultsProps> = ({ match, matchIndex, selectedTournamentIndex, courses }): JSX.Element => {
  const { data: playerList } = useFetchPlayers();
  const players = playerList as Array<Player>;
  const [courseStore, setCourseStore] = useState<Course>();

  useEffect(() => {
    const course = courses.find((aCourse) => aCourse.id === match.courseId);
    if (course) {
      setCourseStore(course);
    }
  }, [courses]);

  return (
    <div>
      <h2>Apply Scores</h2>
      <h3 data-testid="course">Course: {courseStore ? courseStore.name : 'not found'}</h3>
      <h3>Match Format: {MATCH_FORMATS[match.matchFormat as 'tierPoints_6_6_6' | 'tierPoints_1_2_3'].name} </h3>
      {(match.matchFormat === MATCH_FORMATS.tierPoints_6_6_6.id ||
        match.matchFormat === MATCH_FORMATS.tierPoints_1_2_3.id ||
        match.matchFormat === MATCH_FORMATS.stableford.id) && (
        <TeamsDisplay teams={match.teams} selectedTournamentIndex={selectedTournamentIndex} players={players} matchIndex={matchIndex} />
      )}
      {match.matchFormat === MATCH_FORMATS.singles.id && match?.matchPlayMatches && (
        <SinglesDisplay match={match} selectedTournamentIndex={selectedTournamentIndex} players={players} matchIndex={matchIndex} />
      )}
      {match.matchFormat === MATCH_FORMATS.pairs.id && match?.matchPlayMatches && (
        <PairsDisplay match={match} selectedTournamentIndex={selectedTournamentIndex} players={players} matchIndex={matchIndex} />
      )}
    </div>
  );
};
